import Axios from './axios_wrapper'

export function getTargetRefractions() {
  return Axios({
    url: '/target_refractions',
    method: 'GET'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/target_refractions.js
// module id = null
// module chunks = 